import React from 'react'
import cx from 'classnames'
import './Floor.less'
import { goIndex, getParams } from '@/assets/js/utils'

function Floor ({ data, templateType, buriedPointEvent }) {
    let { position, sublist = [], style = {}, trackId } = data
    if (templateType === 'TPL_ONE_PICTURE') {
        sublist.length = 1
    } else if (templateType === 'TPL_TWO_PICTURE') {
        sublist.length = 2
    } else if (templateType === 'TPL_THREE_PICTURE') {
        sublist.length = 3
    } else if (templateType === 'TPL_FOUR_PICTURE') {
        sublist.length = 4
    }
    if (!style) style = {}
    let {
        height,
        isMargin,
        marginTop,
        marginBottom,
        backgroundColor,
        backgroundPicUrl
    } = style

    // 只有一图模版才有isMargin参数,其他模版均有margin值
    if (templateType !== 'TPL_ONE_PICTURE') {
        isMargin = '1'
    }
    const width = isMargin === '0' ? 10 : 9.2
    const param = getParams()
    const type = !!param.type
    const btnStatus = !!param.btnStatus
    // 1图，2图，3图
    const pictureDom = (
        <div className={cx('floor', btnStatus && templateType === 'TPL_ONE_PICTURE' ? 'btn-hide' : '')} style={{
            width: `${width}rem`,
            height: `${(height / 37.5) || 37.7}rem`,
            margin: `${isMargin === '0' ? 0 : 10 / 75}rem ${isMargin === '0' ? 0 : 0.4}rem`
        }}>
            {sublist.map((item, index) => (
                <img
                    src={item.imageUrl}
                    alt={item.title}
                    key={item.id}
                    onClick={() => {
                        buriedPointEvent({
                            button_name: `${trackId}-${item.title}`,
                            button_id: `${item.id}`,
                            button_order: `${index + 1}`,
                            area_order: position,
                            button_area: `${position}-${trackId}`
                        })
                        goIndex(item.url + (type ? '&btnStatus=true' : ''), trackId, item.keyword, {}, true)
                    }}
                    style={{ width: `${width / sublist.length}rem` }}
                    className={cx(templateType === 'TPL_THREE_PICTURE' ? 'threePic' : null, 'statistics-dom')}
                />
            ))}
        </div>
    )

    // 4图
    const fourPictureDom = (
        <div className="fourfloor" style={{
            width: `${width}rem`,
            height: height ? `${height / 18.75}rem` : `${(232 / 37.5)}rem`,
            margin: `${marginTop / 75}rem 0.4rem ${marginBottom / 75}rem 0.4rem`,
            backgroundColor,
            backgroundImage: backgroundPicUrl ? `url(${backgroundPicUrl})` : ''
        }}>
            {sublist.map((item, index) => (
                <p key={item.id}
                    onClick={() => {
                        buriedPointEvent({
                            button_name: `${trackId}-${item.title}`,
                            button_id: `${item.id}`,
                            button_order: `${index + 1}`,
                            area_order: position,
                            button_area: `${position}-${trackId}`
                        })
                        goIndex(item.url, trackId, item.keyword)
                    }}
                    className={'fourPiture statistics-dom'}
                    style={{
                        background: `url(${item.imageUrl}) no-repeat`,
                        backgroundSize: '100% 100%',
                        height: height ? `${height / 37.5}rem` : ''
                    }}></p>
            ))}
        </div>
    )
    return (
        <React.Fragment>
            {templateType === 'TPL_FOUR_PICTURE' ? fourPictureDom : pictureDom}
        </React.Fragment>

    )
}

export default Floor
